"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetEmployeeSummaryOriginalDataResponse () {
        return GetEmployeeSummaryOriginalDataResponse;
    },
    get OriginalDataEmployeeSchema () {
        return OriginalDataEmployeeSchema;
    },
    get OriginalDataFeedbackSampleSchema () {
        return OriginalDataFeedbackSampleSchema;
    },
    get OriginalDataParams () {
        return OriginalDataParams;
    },
    get OriginalDataQuery () {
        return OriginalDataQuery;
    },
    get OriginalDataReviewSampleSchema () {
        return OriginalDataReviewSampleSchema;
    },
    get OriginalDataSamplingMetadataSchema () {
        return OriginalDataSamplingMetadataSchema;
    }
});
const _zod = require("zod");
const _response = require("./response");
const OriginalDataParams = _zod.z.object({
    id: _zod.z.string()
});
const OriginalDataQuery = _zod.z.object({
    timeframe: _response.TimeframeSchema.optional().default("all")
});
const OriginalDataReviewSampleSchema = _zod.z.object({
    id: _zod.z.string(),
    cycle_name: _zod.z.string(),
    submit_date: _zod.z.string().nullable(),
    text: _zod.z.string()
});
const OriginalDataFeedbackSampleSchema = _zod.z.object({
    id: _zod.z.string(),
    author_label: _zod.z.string(),
    last_updated: _zod.z.string().nullable(),
    text: _zod.z.string()
});
const OriginalDataSamplingMetadataSchema = _zod.z.object({
    strategy: _response.SamplingStrategyContractSchema,
    considered_review_ids: _zod.z.array(_zod.z.string()),
    considered_feedback_ids: _zod.z.array(_zod.z.string()),
    returned_review_count: _zod.z.number(),
    returned_feedback_count: _zod.z.number(),
    rejection_reason: _zod.z.string().nullable(),
    sampling_duration_ms: _zod.z.number()
});
const OriginalDataEmployeeSchema = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string(),
    job_title: _zod.z.string().nullable(),
    hire_date: _zod.z.string().nullable(),
    department_id: _zod.z.string().nullable(),
    department_name: _zod.z.string().nullable()
});
const GetEmployeeSummaryOriginalDataResponse = _zod.z.object({
    employee: OriginalDataEmployeeSchema,
    timeframe: _response.TimeframeSchema,
    window: _zod.z.object({
        start: _zod.z.string(),
        end: _zod.z.string()
    }),
    signal_counts: _response.SignalCountsSchema,
    sampled_review_text: _zod.z.array(OriginalDataReviewSampleSchema),
    sampled_feedback_text: _zod.z.array(OriginalDataFeedbackSampleSchema),
    sampling_metadata: OriginalDataSamplingMetadataSchema,
    generation: _response.GenerationInfoSchema,
    source_watermark: _zod.z.string(),
    dumb_mode: _zod.z.boolean()
});
